import React from 'react'
import { makeStyles } from '@material-ui/styles'
import {
    Avatar,
    Grid,
    Skeleton,
    Typography
} from '@material-ui/core'
import { LogoContainer, LogoutButton } from '../Atoms'
import { MainPageContainer } from '../Organisms'
import { useProfile } from '../../utils/Hooks'

const useStyles = makeStyles(() => ({
    avatar: {
        width: 100,
        height: 100,
        fontSize: 50
    },
    main: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-between",
        marginTop: "15vh",
        height: "25vh",
    }
}))

const Profile = () => {
    const classes = useStyles()
    const [userProfile, loading] = useProfile()

    return (
        <LogoContainer style={{ overflowY: "auto !important" }}>
            <MainPageContainer>
                <Grid className={classes.main}>
                    {!loading ?
                        <React.Fragment>
                            <Avatar className={classes.avatar} alt={userProfile.name} src={userProfile.picture}>{userProfile.name[0]}</Avatar>
                            <Typography variant="h6">{userProfile.name}{userProfile.email && ` (${userProfile.email})`}</Typography>
                            <LogoutButton />
                        </React.Fragment> :
                        <React.Fragment>
                            <Skeleton variant="circle" width={100} height={100} />
                            <Skeleton variant="rect" width={300} height={32} />
                            <Skeleton variant="rect" width={300} height={32} />
                            <Skeleton variant="rect" width={300} height={32} />
                        </React.Fragment>
                    }
                </Grid>
            </MainPageContainer>
        </LogoContainer>
    )
}

export default Profile